import { render } from "./RichTextEditor.vue?vue&type=template&id=e708b8ce&scoped=true"
import script from "./RichTextEditor.vue?vue&type=script&lang=js"
export * from "./RichTextEditor.vue?vue&type=script&lang=js"

import "./RichTextEditor.vue?vue&type=style&index=0&id=e708b8ce&scoped=true&lang=css"
import "./RichTextEditor.vue?vue&type=style&index=1&id=e708b8ce&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e708b8ce"]])

export default __exports__